import TeamBadge from "../ones/OnePerson";
import passport from "../assets/passport.jpg"

export default function HomeTeam() {
  // Hardcoded core dataset matching Blessing Management Consultancy executive profiles
  const founders = [
    {
      id: "founder-1",
      name: "CPA Exvery Asheri",
      role: "Managing Partner",
      credentials: "CPA (T)",
      image: passport, // Replace with actual paths
      socials: {
        facebook: "https://facebook.com",
        twitter: "https://x.com",
        linkedin: "https://linkedin.com"
      }
    },
    {
      id: "founder-2",
      name: "CPA Dorcas G. Kimaro",
      role: "Partner & Registered Auditor",
      credentials: "MIT / Adv. Diploma",
      image: passport, 
      socials: {
        facebook: "https://facebook.com",
        twitter: "https://x.com",
        linkedin: "https://linkedin.com"
      }
    },
    {
      id: "founder-3",
      name: "Edson P. Bilikundi",
      role: "Partner & Senior Tax Consultant",
      credentials: "CPA (T) / MBA",
      image: passport,
      socials: {
        facebook: "https://facebook.com",
        twitter: "https://x.com",
        linkedin: "https://linkedin.com"
      }
    }
  ];

  return (
    <section className="premium-team-section">
      <div className="container premium-team-container">
        
        {/* Editorial Section Headers */}
        <div className="row justify-content-center mb-5 text-center" data-aos="fade-up">
          <div className="col-lg-7 col-12">
            <div className="team-editorial-header">
              <div className="team-eyebrow justify-content-center">
                <span className="eyebrow-line" />
                <span className="eyebrow-text">Executive Leadership</span>
                <span className="eyebrow-line" />
              </div>
              <h2 className="team-main-title">
                The Pillars of Our <span className="title-gold-accent">Consultancy</span>
              </h2>
              <p className="team-header-lead mt-3">
                Meet the certified financial engineers and compliance architects steering 
                corporate stability across Tanzania's enterprise landscape.
              </p>
            </div>
          </div>
        </div>

        {/* Dynamic Multi-Column Grid Mapping */}
        <div className="row g-4 style-team-grid-row justify-content-center">
          {founders.map((founder) => (
            <div 
              className="col-lg-4 col-md-6 col-12" 
              key={founder.id}
              data-aos="fade-up"
            >
              <TeamBadge 
                image={founder.image}
                name={founder.name}
                role={founder.role}
                credentials={founder.credentials}
                socials={founder.socials}
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}